import { Box, Button, Tabs } from '@mantine/core';
import { useCompany } from '../Router/CompanyContent';

function openHelp() {
    window.open('https://cloudsaver.com/resources/docs/connection-wizard');
}

export function RemoveAccountBody() {
    return (
        <>
            <Tabs defaultValue="Azure">
                <Tabs.List>
                    <Tabs.Tab value="AWS">AWS</Tabs.Tab>
                    <Tabs.Tab value="Azure">Azure</Tabs.Tab>
                    <Tabs.Tab value="Gcp">GCP</Tabs.Tab>
                </Tabs.List>
                <Tabs.Panel value="AWS" pt="xs">
                    Delete the IAM role for the CloudSaver platform from within your account(s). By default the role is named "CloudSaver-Role".
                </Tabs.Panel>
                <Tabs.Panel value="Azure" pt="xs">
                    <ol style={{ margin: '0', paddingLeft: '16px' }}>
                        <li>
                            Delete role assignments for the subscription intended for disconnect, for all service principles named "Cloudsaver-App-xx.
                        </li>
                        <li>
                            Delete the "Cloudsaver-Role" role <span style={{ fontWeight: 'bold' }}>ONLY IF</span> there are no other Azure
                            subscriptions connected to Cloudsaver.
                        </li>
                        <li>
                            Delete owned applications named "Cloudsaver-App-xx" <span style={{ fontWeight: 'bold' }}>ONLY IF</span> there are no other
                            Azure subscriptions connected to Cloudsaver.
                        </li>
                    </ol>
                </Tabs.Panel>
                <Tabs.Panel value="Gcp" pt="xs">
                    <ol style={{ margin: '0', paddingLeft: '16px' }}>
                        <li>
                            Delete role assignments for the service account intended for disconnect, for all service accounts named "cs-customer-xx".
                        </li>
                        <li>Delete the "Cloudsaver-Access" role.</li>
                        <li>Delete owned applications named "cloudsaver-app-xx" from the project intended for disconnect.</li>
                    </ol>
                </Tabs.Panel>
            </Tabs>
            <Button variant="light" fullWidth mt="md" onClick={openHelp}>
                View Knowledge Base&nbsp;&nbsp;
                <i className="ti ti-external-link"></i>
            </Button>
        </>
    );
}
